module.exports = __webpack_public_path__ + "static/media/job-post-4.60fc0b7e.svg";